import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
export var useFluentPillStyles = makeStyles({
    pill: __assign(__assign(__assign({}, shorthands.margin('0px', '5px')), shorthands.border('1px', 'solid', tokens.colorBrandStroke2)), { color: tokens.colorNeutralForeground1, 
        // body1
        fontFamily: tokens.fontFamilyBase, fontWeight: tokens.fontWeightRegular, fontSize: tokens.fontSizeBase300, lineHeight: tokens.lineHeightBase300, ':hover': {
            cursor: 'pointer',
            backgroundColor: tokens.colorBrandBackground2Hover,
        }, ':active': {
            backgroundColor: tokens.colorBrandBackground2Pressed,
        } }),
    icon: {
        paddingRight: '4px',
        fontSize: '20px',
        paddingTop: '2px',
    },
    dropdownIcon: {
        paddingLeft: '4px',
        color: tokens.colorNeutralForeground1,
        fontSize: '12px',
    },
    likelihoodIconContainer: {
        paddingLeft: '4px',
        height: '16px',
        width: '16px',
    },
    likelihoodIcon: {
        color: tokens.colorNeutralForeground2,
    },
    likelihoodIconSelected: {
        color: tokens.colorNeutralForeground2BrandPressed,
    },
    pillSelected: __assign({ color: tokens.colorNeutralForeground1, fontWeight: tokens.fontWeightSemibold, backgroundColor: tokens.colorBrandBackground2 }, shorthands.border('1px', 'solid', tokens.colorBrandStroke1)),
});
//# sourceMappingURL=FluentPillControl.styles.js.map